var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.stepNumber == 2 ? "block" : "hidden" }, [
    _c("h1", { staticClass: "registration-form-layout__title" }, [
      _vm._v(_vm._s(_vm.spFormTitle))
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "search-preferences-form registration-form-layout registration-form-layout--blue flex"
      },
      [
        _c("p", { staticClass: "registration-form-layout__note" }, [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.locales &&
                  _vm.locales.subscription &&
                  _vm.locales.subscription.search_preferences
              )
            )
          ]),
          _vm._v(
            " " +
              _vm._s(
                _vm.locales &&
                  _vm.locales.subscription &&
                  _vm.locales.subscription.more_accurate_offers
              ) +
              " " +
              _vm._s(
                _vm.locales &&
                  _vm.locales.subscription &&
                  _vm.locales.subscription.you_can_skip
              )
          )
        ]),
        _vm._v(" "),
        _c("theme-autocomplete", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "`required`"
            }
          ],
          attrs: {
            name: "location_id[]",
            label: _vm.spCityTitle,
            endpoint: "/admin/autocomplete/locations",
            resolve: function(item) {
              return item.name
            },
            placeholder:
              _vm.locales &&
              _vm.locales.subscription &&
              _vm.locales.subscription.add_location,
            isRequired: true
          }
        }),
        _vm._v(" "),
        _c("theme-districts-dropdown", {
          attrs: {
            data: [],
            name: "districts[]",
            label: _vm.spDistrictTitle,
            placeholder: _vm.spDistrictPlaceholder,
            "district-input": true
          }
        }),
        _vm._v(" "),
        _c("theme-select", {
          attrs: {
            name: "distance",
            label: _vm.spDistanceTitle,
            value: _vm.spDistanceValue,
            options: _vm.spDistanceOptions
          }
        }),
        _vm._v(" "),
        _c("theme-input", {
          attrs: {
            label: _vm.spRentalTextTitle,
            name: "rental_text",
            placeholder: _vm.spRentalTextPlaceholder
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7"
          },
          [
            _c("theme-calendar", {
              attrs: {
                label: _vm.spStartDateRentTitle,
                name: "rental_starts_at",
                placeholder: _vm.spStartDateRentPlaceholder
              }
            }),
            _vm._v(" "),
            _c(
              "theme-input",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|numeric",
                    expression: "`required|numeric`"
                  }
                ],
                attrs: {
                  label: _vm.spWeekPriceTitle,
                  name: "week_price",
                  isRequired: true,
                  placeholder: "0,00",
                  isExtraInfo: true
                }
              },
              [
                _c("template", { slot: "extra-info" }, [
                  _c("span", { staticClass: "text-black" }, [_vm._v("€")])
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("theme-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|numeric",
                  expression: "`required|numeric`"
                }
              ],
              attrs: {
                label: _vm.spNumberOfMenTitle + ", male",
                name: "number_of_men",
                isRequired: true,
                placeholder: _vm.spNumberOfMenPlaceholder
              }
            }),
            _vm._v(" "),
            _c("theme-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|numeric",
                  expression: "`required|numeric`"
                }
              ],
              attrs: {
                label: _vm.spNumberOfWomenTitle,
                name: "number_of_women",
                isRequired: true,
                placeholder: _vm.spNumberOfWomenPlaceholder
              }
            }),
            _vm._v(" "),
            _c("theme-select", {
              attrs: {
                label: _vm.spBedroomsTitle,
                value: _vm.spBedroomsValue,
                name: "min_number_of_bedrooms",
                options: _vm.spBedroomsOptions
              }
            }),
            _vm._v(" "),
            _c("theme-select", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "`required`"
                }
              ],
              attrs: {
                label: _vm.spParkingPlacesTitle,
                value: "0",
                name: "parking_places",
                options: _vm.spParkingPlacesOptions,
                isRequired: true
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("theme-textarea", {
          attrs: {
            label: _vm.spExtraInformationTitle,
            name: "searchprofile_subscriber_note",
            placeholder: _vm.spExtraInformationPlaceholder
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "theme-btn theme-btn--block theme-btn--primary",
            attrs: { id: "submitSearchPreferencesFormBtn", type: "submit" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.submitForm.apply(null, arguments)
              }
            }
          },
          [_vm._v("\n        Submit\n      ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2847cd64", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2847cd64","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SearchPreferencesFormSH.vue
// module id = 653
// module chunks = 1